// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"Statistics_progressBar__kRoll"};